import { Injectable } from '@angular/core'
import { ODataConfiguration } from '@exchange/services/core/odata'
import { IModelBase } from 'common-components'
import { HttpClient } from '@angular/common/http'
import { ODataService } from 'common-services'

export enum EpisodeType {
  Medical = 1,
  Surgical
}

export interface IUserAdditionalData extends IModelBase {
  UserId: string
  NurseTypeId: number
  Npi: string
}

@Injectable()
export class UserAdditionalDataODataService extends ODataService<IUserAdditionalData> {
  constructor(
    protected http: HttpClient,
    protected config: ODataConfiguration
  ) {
    super(http, config)
    this.typeName = 'UserAdditionalData'
  }
}
